module.exports = __webpack_public_path__ + "fonts/SFCompactDisplay-Bold.713b226.otf";